import React from 'react';
import './ItemCard.css';
import Tooltip from '@mui/material/Tooltip';

const CornerDownRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-corner-down-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M6 6v6a3 3 0 0 0 3 3h10l-4 -4m0 8l4 -4" /></svg>
);

const getColor = (val, status, modified) => {
  if (status === "completed") return '';
  if (modified || modified === undefined) return '';
  if (val < 0.5) return 'error-text';
  if (val < 0.8) return 'warning-text';
  if (!val) return '';
  return '';
};

const ItemCard = ({ dimensions, type, fulfillmentLocation, fragile, single = false, name, lotStatus, isManuallyModified }) => {
  return (
  <div className="item-card">
    {!single && (
    <>
      <CornerDownRightIcon />
      <div className="item-card-section">
        <div className="item-card-label">Object Name</div>
        <Tooltip title={name.value} placement="right" arrow>
          <div id="item-name" className="item-card-value">{name.value || <span className="error-text">Missing Data</span>}</div>
        </Tooltip>
      </div>
    </>
    )}
    <div className="item-card-section">
      <div className="item-card-label">Dimensions</div>
      <Tooltip title={getColor(dimensions.conf, lotStatus, isManuallyModified) === '' ? dimensions.value : 'Low confidence value'} placement="right" arrow>
        <div id="item-dimensions" className={`${getColor(dimensions.conf, lotStatus, isManuallyModified)} item-card-value`}>{dimensions.value || <span className="error-text">Missing Data</span>}</div>
      </Tooltip>
    </div>
    <div className="item-card-section">
      <div className="item-card-label">Type</div>
      <Tooltip title={getColor(type.conf, lotStatus, isManuallyModified) === '' ? type.value : 'Low confidence value'} placement="right" arrow>
        <div id="item-type" className={`${getColor(type.conf, lotStatus, isManuallyModified)} item-card-value`}>{type.value || <span className="error-text">Missing Data</span>}</div>
      </Tooltip>
    </div>
    { single && (
    <div className="item-card-section">
      <div className="item-card-label">Fulfillment Location</div>
      <Tooltip title={fulfillmentLocation} placement="right" arrow>
        <div id="item-fulfillment" className="item-card-value">{fulfillmentLocation || <span className="error-text">Missing Data</span>}</div>
      </Tooltip>
    </div>
    )}
    <div className="item-card-section">
      <div className="item-card-label">Fragile</div>
      <Tooltip title={getColor(fragile.conf, lotStatus, isManuallyModified) === '' ? (fragile.value ? 'Yes' : 'No') : 'Low confidence value'} placement="right" arrow>
        <div id="item-fragile" className={`${getColor(fragile.conf, lotStatus, isManuallyModified)} item-card-value`}>{fragile.value ? 'Yes' : 'No'}</div>
      </Tooltip>
    </div>
  </div>
)};

export default ItemCard;
